/**
 * Theme mode vocabulary for admin-web.
 *
 * Storage contract: absence of {@link THEME_STORAGE_KEY} means "System" —
 * `THEME_MODE.System` is in-memory only and is never written to storage.
 */
export const THEME_MODE = {
  Light: "light",
  Dark: "dark",
  System: "system",
} as const;

export type ThemeMode = (typeof THEME_MODE)[keyof typeof THEME_MODE];

/** The two modes that are ever persisted (System = absence of the key). */
export type StoredThemeMode = typeof THEME_MODE.Light | typeof THEME_MODE.Dark;

/**
 * localStorage key for the persisted theme preference (naming matches
 * `admin_access_token`). Mirrored verbatim by the pre-bootstrap script in
 * index.html — a structural spec pins the two against drift.
 */
export const THEME_STORAGE_KEY = "admin_theme_mode";

/**
 * Class applied to `<html>` that scopes the dark Material theme emission in
 * styles.scss. Mirrored verbatim by the index.html pre-bootstrap script.
 */
export const THEME_DARK_CLASS = "admin-dark";
